import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useKomutStore } from "@lib/store";
import { ROUTES } from "@utils/navigation/routes";

export function ProtectedRoute() {
  const userInfo = useKomutStore((s) => s.userInfo);
  const clientSessionResolved = useKomutStore((s) => s.clientSessionResolved);
  const location = useLocation();

  if (!clientSessionResolved) {
    return (
      <div className="flex min-h-[50dvh] items-center justify-center text-muted-foreground">
        Loading…
      </div>
    );
  }

  if (!userInfo) {
    const returnUrl = `${location.pathname}${location.search}`;
    return (
      <Navigate
        to={`${ROUTES.AUTH.SIGNIN}?returnUrl=${encodeURIComponent(returnUrl)}`}
        replace
      />
    );
  }

  return <Outlet />;
}
